<div class="m-content" xmlns="http://www.w3.org/1999/html">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'revenue-report.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>
            <div class="filter">
              <small>{{ 'revenue-report.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date"></hx-date-range-select>
            </div>
            <div class="filter">
              <small>{{ 'revenue-report.payment' | transloco }}</small>
              <hx-enum-select [(ngModel)]="params.paymentTypes" [multiple]="true" enumName="PaymentType"
                              [enumType]="PaymentType"></hx-enum-select>
            </div>
            <div class="filter">
              <small>{{ 'revenue-report.categories' | transloco }}</small>
              <hx-product-category-select [(ngModel)]="params.categoryIds" [multiple]="true" [brandId]="brandId"></hx-product-category-select>
            </div>
            <div class="filter">
              <small>{{ 'revenue-report.limit' | transloco }}</small>
              <ng-select class="limit" [items]="limits" bindLabel="id" bindValue="id" [(ngModel)]="params.limit"></ng-select>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-12 text-left">
              <button type="button" *ngIf="params.storeIds.length === 1" (click)="generate()" class="btn btn-outline-success m--margin-right-10"
                      [ngbTooltip]="'download' | transloco" [disabled]="isLoading.generate"
                      [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.generate}">
                <label class="label">{{ 'download' | transloco }}</label>
              </button>

              <button type="button" (click)="applyFilters()" class="btn btn-outline-primary m--margin-right-10"
                      [ngbTooltip]="'search' | transloco" [disabled]="isLoading.list"
                      [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.list}">
                <label class="label">{{ 'search' | transloco }}</label>
              </button>
            </div>

          </div>

          <hr>

          <div class="org-title" *ngIf="params.storeIds.length === 1">
            {{ 'revenue-report.organization' | transloco }}: {{ organization?.title | uiLabel }}
          </div>
          <div class="store-title" *ngIf="params.storeIds.length === 1">
            {{ 'revenue-report.shop' | transloco }}: {{ store?.title | uiLabel }}
          </div>
          <br/>
          <br/>
          <div class="report-title" *ngIf="params.storeIds.length === 1">
            {{ 'reports.revenue' | transloco }} {{ 'revenue-report.behind' | transloco }} {{ params.date?.from | date:'dd.MM.yyyy' }}
            - {{ params.date?.to | date:'dd.MM.yyyy' }}
          </div>
          <br/>
          <div *ngIf="productRevenueList.length && !isLoading.list" class="block-table-scroll">
            <table>
              <thead>
              <tr class="fixed-head-oline">
                <th class="text-center fixed-head-one" rowspan="2">{{ 'revenue-report.table.head.name' | transloco }}</th>
                <th class="text-center fixed-head-two" rowspan="2">{{ 'revenue-report.table.head.nomenclature' | transloco }} <br>{{ 'revenue-report.table.head.code' | transloco }}</th>
                <th class="text-center fixed-head-three" rowspan="2">{{ 'revenue-report.table.head.unit' | transloco }} <br>{{ 'revenue-report.table.head.change' | transloco }}</th>
                <th class="text-center fixed-head-fourth" rowspan="2">{{ 'revenue-report.table.head.store' | transloco }}</th>
                <th *ngFor="let cmn of columns" class="text-center" colspan="3">
                  {{'paymentType.' + cmn | transloco}}
                </th>
                <th class="text-center" rowspan="2">{{ 'revenue-report.table.head.total' | transloco }}</th>
                <th class="text-center" rowspan="2">{{ 'revenue-report.table.head.currency' | transloco }}</th>
              </tr>
              <tr class="fixed-head-tline">
                <ng-container *ngFor="let cmn of columns">
                  <th>{{ 'revenue-report.table.head.amount' | transloco }}</th>
                  <th>{{ 'revenue-report.table.head.sum' | transloco }}</th>
                  <th>{{ 'revenue-report.table.head.discount' | transloco }}</th>
                </ng-container>
              </tr>
              </thead>
              <tbody class="tbody-fixed">
              <ng-container *ngFor="let even = even;let i = index; let productRevenue of productRevenueList">
                <tr>
                  <td class="tbody-fixed-one">{{ productRevenue.productTitle | uiLabel }}</td>
                  <td class="tbody-fixed-two">{{ productRevenue.productExt1cCode }}</td>
                  <td class="tbody-fixed-three">{{ productRevenue.unitOfMeasureTitle | uiLabel }}</td>
                  <td class="tbody-fixed-fourth">{{ storeMap.get(productRevenue.storeId)?.title | uiLabel }}</td>
                  <ng-container *ngFor="let pt of productRevenue.payments">
                    <td>{{ pt.amount }}</td>
                    <td>{{ pt.value }}</td>
                    <td>{{ pt.discount }}</td>
                  </ng-container>
                  <td>{{ productRevenue.totalValue }}</td>
                  <td>{{ storeCurrencyMap.get(productRevenue.storeId) }}</td>
                </tr>
              </ng-container>
              </tbody>
              <tfoot class="table-footer-fixed">
              <tr>
                <th>{{ 'revenue-report.table.head.total' | transloco }}</th>
                <th></th>
                <th></th>
                <th></th>
                <ng-container *ngFor="let pt of reportTotalInfo.payments">
                  <th>{{ pt.amount }}</th>
                  <th colspan="2" style="text-align: right">{{ pt.value }}</th>
                </ng-container>
                <th style="text-align: right">{{ reportTotalInfo.total }}</th>
                <th></th>
              </tr>
              </tfoot>
            </table>
          </div>
          <hx-loader [length]="productRevenueList.length" [isLoading]="isLoading.list"></hx-loader>
          <br/>
          <br/>

          <div class="m--align-center" *ngIf="productRevenueList.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="params.page" [pageSize]="params.limit"
                            (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
